/**
 * Envision customizations
 * assets/product-custom.js
 *
 * Product custom JavaScript
 */

(function () {

  /**
   * Build a Set & Save button
   */

  // The Liquid in main-product.liquid decides which variants get the button and lists
  // them in data-variant-ids (",id1,id2,"); this only applies that list on variant change.
  document.addEventListener('on:variant:change', function (evt) {
    const giftSetButton = evt.detail.form?.querySelector('.product-info__build-a-set-link');
    if (!giftSetButton) return;

    const variant = evt.detail.variant;
    giftSetButton.hidden = !variant || !giftSetButton.dataset.variantIds.includes(`,${variant.id},`);

    if (variant) {
      const updatedHref = giftSetButton.getAttribute('href').replace(/variant=\d+/, `variant=${variant.id}`);
      giftSetButton.setAttribute('href', updatedHref);
    }
  });

  /**
   * Categories block
   */

  let categories = document.querySelectorAll("div.tags > a.tag-item");
  const showMoreBtn = document.querySelector(".tags__show-more");

  function show_more_categories(event) {
    event.preventDefault();

    categories.forEach((item, index) => {
      if (index >= 4) item.style.display = "";
      if (index == 4)
        item.focus();
    });

    if (showMoreBtn) {
      showMoreBtn.textContent = "Show Less";
      showMoreBtn.setAttribute("aria-expanded", "true");
      showMoreBtn.onclick = show_less_categories;
    }
  }

  function show_less_categories(event) {
    event.preventDefault();

    categories.forEach((item, index) => {
      if (index >= 4) item.style.display = "none";
    });

    categories[categories.length - 1].focus();

    // Make sure the show more button itself is always visible
    if (showMoreBtn) {
      showMoreBtn.style.display = "";
      showMoreBtn.textContent = "Show More";
      showMoreBtn.setAttribute("aria-expanded", "false");
      showMoreBtn.onclick = show_more_categories;
    }
  }

  // Initial state: hide categories >= 4, but never hide the show more button
  categories.forEach((item, index) => {
    if (index >= 4) item.style.display = "none";
  });

  if (showMoreBtn) {
    showMoreBtn.style.display = "";
    showMoreBtn.onclick = show_more_categories;
  }

  /**
   * Stamped badge
   */

  const wrapTextNodes = (element) => {
    const textNodes = Array.from(element.childNodes).filter(
      (node) => node.nodeType === Node.TEXT_NODE
    );
    textNodes.forEach((textNode) => {
      const span = document.createElement("span");
      span.appendChild(textNode.cloneNode());
      textNode.parentNode.replaceChild(span, textNode);
    });
  };

  const productMetaObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        const newStampedBadge = mutation.target.querySelector(
          ".stamped-badge-caption"
        );
        if (newStampedBadge) {
          wrapTextNodes(newStampedBadge);
        }
      }
    });
  });

  const productMeta = document.querySelector(".product-info");
  if (productMeta) {
    productMetaObserver.observe(productMeta, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * Gift bag add-on: update UI on variant change and on load
   */
  (function giftBagAddon() {
    const productSection = document.querySelector('.js-product');
    if (!productSection) return;

    const productForm = productSection.querySelector('.js-product-form-main');
    const giftBagContainer = productSection.querySelector('.add__gift-bag');
    if (!productForm || !giftBagContainer) return;

    // Parse per-variant for_products counts
    let variantForProductsCounts = {};
    let productData = null;
    try {
      const variantPicker = productSection.querySelector('variant-picker');
      if (variantPicker) {
        const dataEl = variantPicker.querySelector('script[type="application/json"]');
        if (dataEl) productData = JSON.parse(dataEl.textContent);
      }
    } catch (e) {}

    try {
      const productId = productData?.product?.id;
      if (productId) {
        const countsEl = document.getElementById(`variant-for-products-${productId}`);
        if (countsEl) variantForProductsCounts = JSON.parse(countsEl.textContent || '{}');
      }
    } catch (e) {}

    function parseLeadingInteger(text) {
      if (!text) return 0;
      const match = String(text).match(/(\d+)/);
      return match ? parseInt(match[1], 10) : 0;
    }

    function computeGiftBagQtyFromCount(count) {
      if (!count || count <= 0) return 0;
      if (count <= 12) return 1;
      if (count <= 24) return 2;
      if (count <= 36) return 3;
      if (count <= 48) return 4;
      return 5;
    }

    function updateGiftBagUI(variant) {
      if (!variant) return;

      const forProductsCount = variantForProductsCounts?.[variant.id] || 0;
      // Only show if variant has for_products metafield populated
      if (!forProductsCount) {
        giftBagContainer.style.display = 'none';
        giftBagContainer.dataset.qty = '0';
        const checkbox = giftBagContainer.querySelector('#GiftBagCheckbox');
        if (checkbox) checkbox.checked = false;
        return;
      }

      // Determine number of products for phrasing: prefer number in title else fall back to metafield count
      let numProducts = parseLeadingInteger(variant.title) || forProductsCount;

      const qty = computeGiftBagQtyFromCount(numProducts);

      giftBagContainer.style.display = '';
      giftBagContainer.dataset.qty = String(qty);

      const label = giftBagContainer.querySelector('.gift-bag__label');
      if (label) {
        const money = label.dataset.price || '';
        const phrase = qty === 1 ? 'Add a gift bag' : `Add ${qty} gift bags`;
        const suffix = numProducts > 12 ? ' ea' : '';
        label.textContent = `${phrase} (${money}${suffix})`;
      }
    }

    function getCurrentVariant() {
      if (!productData) return null;
      const idInput = productForm.querySelector('input[name="id"]');
      if (!idInput) return null;
      const id = parseInt(idInput.value, 10);
      if (!id) return null;
      return productData.product.variants.find(v => v.id === id) || null;
    }

    // Initial render
    updateGiftBagUI(getCurrentVariant());

    // Update on variant change
    document.addEventListener('on:variant:change', function (evt) {
      if (!evt?.detail?.variant) return;
      // Ensure this event is for this product section
      if (evt.target && !productSection.contains(evt.target)) return;
      updateGiftBagUI(evt.detail.variant);
    });

    async function addGiftBagsIfNeeded() {
      try {
        const giftBagCheckbox = giftBagContainer.querySelector('#GiftBagCheckbox');
        const bagVariantId = giftBagContainer.dataset.giftBagVariantId;
        const bagQty = parseInt(giftBagContainer.dataset.qty || '0', 10);
        if (!(giftBagCheckbox && giftBagCheckbox.checked && bagVariantId && bagQty > 0)) return;

        const parentVariant = getCurrentVariant();
        const parentVariantId = parentVariant ? parentVariant.id : null;

        const addEndpoint = theme.routes.cartAdd.endsWith('.js') ? theme.routes.cartAdd : `${theme.routes.cartAdd}.js`;
        const resp = await fetch(addEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(bagVariantId, 10), quantity: bagQty, properties: {
            _gift_bag: 'true',
            _gift_bag_parent_variant_id: parentVariantId ? String(parentVariantId) : '',
            _gift_bag_units_per_parent: String(bagQty)
          } }] })
        });
        if (!resp.ok) return;
        // Ask the drawer to fully refresh after the extra add
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { detail: { dontRefreshCartItems: true } }));
      } catch (_) {}
    }

    // Listen for theme cart events and add bags after base add completes
    document.addEventListener('on:cart:add', async (evt) => {
      if (evt.target && !productSection.contains(evt.target)) return;
      await addGiftBagsIfNeeded();
    });
    document.addEventListener('on:line-item:change', async (evt) => {
      if (evt.target && !productSection.contains(evt.target)) return;
      await addGiftBagsIfNeeded();
    });
  })();

  /**
   * Show sticky ATC after some scroll
   */

  window.addEventListener("scroll", () => {
    const triggerPoint = document.querySelector("div.product button[name=add]").getBoundingClientRect().top;
    const sticky_atc = document.querySelector("div.sticky-atc");

    if (triggerPoint <= 0) {
      sticky_atc.classList.remove("hidden");
    } else {
      sticky_atc.classList.add("hidden");
    }
  });

  /**
   * Changes Klaviyo's notify me when available button placement
   */

  function waitForElement(selector, callback, interval = 100) {
    const check = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(check);
        callback(el);
      }
    }, interval);
  }

  function klaviyoPlacement(link) {
    let klaviyo_link = document.querySelector("a.klaviyo-bis-trigger");
    let klaviyo_link_copy = klaviyo_link.cloneNode(true);

    klaviyo_link.remove();
    klaviyo_link_copy.classList.add("btn", "btn--primary", "w-full");
    klaviyo_link_copy.style = "";
    document.querySelector(".product-info__add-button").insertAdjacentElement("beforeend", klaviyo_link_copy);
  }

  waitForElement("a.klaviyo-bis-trigger", klaviyoPlacement);

})();
